import { ButtonV3, LayoutGrid, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import JapanSizeInStore from './JapanSizeInStore';

interface InStoreAvailableProps {
  readonly isBestBuyLinkActive: boolean;
  readonly isBestBuyCountry: boolean;
  readonly isJapan: boolean;
}

const InStoreAvailable = ({
  isBestBuyLinkActive,
  isBestBuyCountry,
  isJapan,
}: InStoreAvailableProps): JSX.Element => {
  const t = useTranslations();
  return (
    <LayoutGrid className="mt-24" id="size-in-store" data-cy="size-in-store">
      <div className="col-main lg:col-end-13">
        <TypographyV3 variant="h4" Element="h2" height="none" className="mb-6">
          {t('sizing_in_store_now')}
        </TypographyV3>
      </div>

      {isBestBuyLinkActive && isBestBuyCountry && (
        <>
          <div
            className="col-main mb-6 lg:col-start-13 lg:mb-12"
            data-cy="visit-best-buy-store"
          >
            <TypographyV3 weight="bold">Best Buy</TypographyV3>
            <TypographyV3 variant="body-large" className="max-w-lg">
              {t('sizing_bestbuy_store')}
            </TypographyV3>
            <ButtonV3
              className="mt-6"
              variant="secondary-dark"
              href="/best-buy/store-locator"
            >
              {t('sizing_bestbuy_store_locator')}
            </ButtonV3>
          </div>
        </>
      )}

      {isJapan && <JapanSizeInStore />}
    </LayoutGrid>
  );
};

export default InStoreAvailable;
